/**
 * Verkorte schrijfwijzen van plaatsnamen zoals mensen ze intypen:
 * "Capelle aan den IJssel" wordt ook gezocht als "Capelle a/d IJssel".
 *
 * Alleen echte, gangbare afkortingen — nooit verzonnen varianten.
 */

const RULES: [RegExp, string][] = [
  [/ aan den /g, " a/d "],
  [/ aan de /g, " a/d "],
  [/ aan 't /g, " a/d "],
];

/** Verkorte varianten van een plaatsnaam, zonder duplicaten en zonder de naam zelf. */
export function shortNameVariants(name: string): string[] {
  const out = new Set<string>();
  for (const [re, replacement] of RULES) {
    const short = name.replace(re, replacement);
    if (short !== name) out.add(short);
  }
  out.delete(name);
  return [...out];
}

/** Eén verkorte variant, of null als de naam niet af te korten is. */
export function shortName(name: string): string | null {
  return shortNameVariants(name)[0] ?? null;
}
